import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDjcgbcjfVNbHezvrrCjrfkqZPrUi0Fl0U",
  authDomain: "tatilarkadasim-db5b1.firebaseapp.com",
  projectId: "tatilarkadasim-db5b1",
  storageBucket: "tatilarkadasim-db5b1.firebasestorage.app",
  messagingSenderId: "411949261260",
  appId: "1:411949261260:web:48642c71fefda490a93d69"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export { app };
export default app;
